import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=95a48986&scoped=true"
import script from "./DateRange.vue?vue&type=script&lang=js"
export * from "./DateRange.vue?vue&type=script&lang=js"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=95a48986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a48986",
  null
  
)

export default component.exports